import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { workspacesApi as n } from "@maat/api-main";
import { useAuth as r } from "@maat/store-auth";
//#region src/workspaces/useWorkspaceResponseStatsQuery.ts
var i = (i) => {
	let { activeWorkspaceId: a } = r();
	return t({
		queryKey: e.responseStats(a ?? void 0),
		queryFn: () => n.getResponseStats(),
		enabled: !!a && (i?.enabled ?? !0),
		staleTime: 10 * 6e4
	});
};
//#endregion
export { i as useWorkspaceResponseStatsQuery };
